import { plainToClassFromExist } from 'class-transformer';
import { LiveDataReport } from '../model/live-data-report/live-data-report';
import { LiveDataReportType } from '../model/live-data-report/live-data-report-type';
import { AlcoholLockReport } from '../model/live-data-report/alcohol-lock-report';
import { PanicButtonReport } from '../model/live-data-report/panic-button-report';
import { RouteControlReport } from '../model/live-data-report/route-control-report';
import { VehicleOffCourseReport } from '../model/live-data-report/vehicle-off-course-report';
import { ClassType } from 'class-transformer/ClassTransformer';

export function parseReport(reportObject: any): LiveDataReport<any> {
  if (reportObject.hasOwnProperty('report_type') || reportObject.hasOwnProperty('reportType')) {
    const reportType: LiveDataReportType = reportObject.report_type || reportObject.reportType;
    const classType = getClassType(reportType);
    if (classType) {
      const report: LiveDataReport<any> =
        plainToClassFromExist(new LiveDataReport<typeof classType>(classType), reportObject);
      return report;
    }
  }
  console.error('Couldn\'t parse incoming report', reportObject);
  return null;
}

export function parseReports(data: LiveDataReport<any>[]): LiveDataReport<any>[] {
  const reports: LiveDataReport<any>[] = [];
  data.forEach(inputReport => {
    const report = parseReport(inputReport);
    if (report)
      reports.push(report);
  });
  return reports;
}

function getClassType(reportType: LiveDataReportType): ClassType<any> | null {
  switch (reportType) {
    case LiveDataReportType.ALCOHOL_LOCK:
      return AlcoholLockReport;
    case LiveDataReportType.PANIC_BUTTON:
      return PanicButtonReport;
    case LiveDataReportType.ROUTE_CONTROL:
      return RouteControlReport;
    case LiveDataReportType.OFF_COURSE:
      return VehicleOffCourseReport;
    default:
      return null;
  }
}
